import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { UiStateService } from 'src/app/services/utilities/ui-state.service';

@Component({
  selector: 'app-dashboard-page-header',
  templateUrl: './dashboard-page-header.component.html',
  styleUrls: ['./dashboard-page-header.component.scss']
})
export class DashboardPageHeaderComponent {
  @Input() platformName: string = '';
  @Input() data:any
  dateRange:any={}
  @Input() hasNoPages:boolean=false
  @Output() selectedDateRange= new EventEmitter<any>();
  subs:Subscription[] = [];
  constructor(private uiStateService:UiStateService) { }
  ngOnInit(): void {
    this.subs.push(
      this.uiStateService.pageStatsdateRangeUpdate$.subscribe((dateRange) => {
        //  console.log('🔵[dashboard-page-header] new dateRange:', dateRange);
        this.dateRange = dateRange;
        // this.updateStats(dateRange);
      })
    )
  }

  setupDefaultDateRange(){
    switch(this.platformName){
      case 'google':
        this.dateRange = {
          startDate: new Date(new Date().setDate(new Date().getDate() - 180)),
          endDate: new Date(new Date().setDate(new Date().getDate())),
        };
        break;
      case 'facebook':
        this.dateRange = {
          startDate: new Date(new Date().setDate(new Date().getDate() - 28)),
          endDate: new Date(new Date().setDate(new Date().getDate())),
        };
        break;
      case 'instagram':
        this.dateRange = {
          startDate: new Date(new Date().setDate(new Date().getDate() - 28)),
          endDate: new Date(new Date().setDate(new Date().getDate() )),
        };
        break;
      case 'linkedin':
        this.dateRange = {
          startDate: new Date(new Date().setDate(new Date().getDate() - 364)),
          endDate: new Date(new Date().setDate(new Date().getDate() - 2)),
        };
        break;
    }
  }
  getSelectedDateRange() {
     this.dateRange.startDate = this.dateRange?.pageStatsstartDate ? this.dateRange?.pageStatsstartDate : this.dateRange?.startDate
     this.dateRange.endDate = this.dateRange?.pageStatsendDate ? this.dateRange.pageStatsendDate : this.dateRange.endDate
    const startDate = new Date(this.dateRange.startDate) ;
    const endDate =  new Date(this.dateRange.endDate) ;
    if (!startDate || !endDate) {
     // this.setupDefaultDateRange()
      return 'Invalid date range';
    }
    if(endDate?.toISOString().split('T')[0]==new Date().toISOString().split('T')[0]){
      if(this.platformName=='linkedin'){
        endDate.setDate(endDate.getDate() - 2);
      }
    }
    
    if( startDate.toISOString().split('T')[0]==endDate.toISOString().split('T')[0]){
      return `${startDate.getDate().toString().padStart(2, "0")}/${(startDate.getMonth() + 1).toString().padStart(2, "0")}/${startDate.getFullYear()}`
    }

    if (startDate && endDate) {
      return `${startDate.getDate().toString().padStart(2, "0")}/${(startDate.getMonth() + 1).toString().padStart(2, "0")}/${startDate.getFullYear()} - ${endDate.getDate().toString().padStart(2, "0")}/${(endDate.getMonth() + 1).toString().padStart(2, "0")}/${endDate.getFullYear()}`;
    }
  
    return 'Invalid date range';
  }
  updateStats(data:any){
    if(!data.startDate || !data.endDate){
     
    }
    
    this.selectedDateRange.emit(data);
    
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
